import { render, staticRenderFns } from "./EditDetail.vue?vue&type=template&id=6db101a8"
import script from "./EditDetail.vue?vue&type=script&lang=js"
export * from "./EditDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports